export enum MenuOptionNames {
  UPCOMING = 'upcoming',
  PAST = 'past',
}

export enum ReservationViewNames {
  HOST = 'host',
  GUEST = 'guest',
}

export enum ReservationSortBy {
  BookingStart = 'BookingStart',
  CreatedAt = 'CreatedAt',
}
